import { showAllNonBaseMenuItem } from 'weixin-js-sdk';
<template>
  <div class="summary-wrapper">
    <div class="form disease-wrapper">
      <div class="title">可能疾病</div>
      <textarea
        auto-height
        placeholder="请填写用户可能患有的疾病，最多20字"
        placeholder-style="color: #C2C2C2;font-size:15px"
        class="textarea"
        maxlength="20"
        :value="diseaseValue"
        @input="onInputDisease"
      />
    </div>
    <div class="form resolution">
      <div class="title">处理意见(单选)</div>
      <div class="resolution-list">
        <!-- <radio-group class="resolution-list" @change="radioChange">
          <label
            v-for="item in resolutionList"
            :key="item.index"
            class="resolution-list"
          >
            <div class="checkbox">
              <span class="resolution-span">{{ item.span }}</span>
              <radio :value="item.value" color="#1B91E0" />
            </div>
          </label>
        </radio-group> -->
        <cube-radio-group v-model="handleValue" :options="resolutionList" />
      </div>
    </div>
    <div class="form suggest-detail">
      <div class="title">意见详情</div>
      <textarea
        placeholder="请根据选择的处理意见，给出详细描述，或补充更多处理意见，最多500字"
        placeholder-style="color: #C2C2C2;font-size:15px"
        class="textarea textarea-suggest"
        maxlength="500"
        cursor-spacing="120"
        :value="suggestValue"
        @input="onInputSuggest"
      />
    </div>
    <div class="submit-button">
      <div class="button" @click="onSubmit">
        发送给患者
      </div>
    </div>
  </div>
</template>
<script>
import { postInquirySummary } from '@/services/index';
import NativeBridge from '@cy/native-bridge';
import * as cyDetect from '@cy/detect';

export default {
  name: 'KangLe',
  data() {
    return {
      resolutionList: [
        {
          value: 0,
          label: '正常现象，不必担心',
        },
        {
          value: 1,
          label: '改善生活方式，加强锻炼',
        },
        {
          value: 2,
          label: '线上无法确诊，需去医院面诊或检查',
        },
        {
          value: 3,
          label: '药物治疗',
        },
        {
          value: 4,
          label: '去医院进一步治疗',
        },
        {
          value: 5,
          label: '其他',
        },
      ], // 意见列表
      diseaseValue: '', // 可能疾病
      handleValue: 0, // 处理意见
      suggestValue: '', // 意见详情
      orderId: this.$route.query.orderID, // 订单ID
    };
  },
  methods: {
    /**
     * 处理意见选择
     *
     * @param value
     */
    radioChange(value) {
      this.setData({
        handleValue: value.detail.value,
      });
    },
    /**
     * 提交总结
     */
    async onSubmit() {
      if (!this.diseaseValue) {
        this.$createToast({
          time: 1000,
          txt: '请填写可能疾病',
          type: 'txt',
        }).show();
        return;
      }
      if (!this.suggestValue) {
        this.$createToast({
          time: 1000,
          txt: '请填写意见详情',
          type: 'txt',
        }).show();
        return;
      }

      const params = {
        id: this.orderId,
        possible_disease: this.diseaseValue,
        suggestion: this.resolutionList[this.handleValue].label,
        suggestion_detail: this.suggestValue,
      };
      console.log(params, 'params');
      const { error_code, error_msg } = await postInquirySummary(params);
      console.log(error_code, 'error_code');
      if (error_code === 0) {
        this.$createToast({
          time: 1000,
          txt: '发送成功',
          type: 'txt',
        }).show();
        if (cyDetect.isFromCYClinic()) {
          NativeBridge.closeWebView();
        }
      } else {
        this.$createToast({
          time: 1000,
          txt: error_msg || '发送失败',
          type: 'txt',
        }).show();
      }
    },
    /**
     * 输入疾病
     *
     * @param e
     */
    onInputDisease(e) {
      console.log(e);
      this.diseaseValue = e.target.value;
    },
    /**
     * 输入处理意见
     *
     * @param e
     */
    onInputSuggest(e) {
      this.suggestValue = e.target.value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
::v-deep .cube-radio-ui {
  border: 1px solid #39d167;
}
textarea {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
}
.summary-wrapper {
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: #f7f7f7;
}
.form {
  box-sizing: border-box;
  width: 100vw;
  margin-bottom: rem(10);
  padding: rem(15);
  background: #fff;
}
.title {
  padding-bottom: rem(15);
}
.title::after {
  margin-left: rem(4);
  color: #ff6134;
  opacity: 0.8;
  content: '*';
}
.textarea {
  color: #323232;
  font-size: rem(15);
}
.resolution-text {
  color: #323232;
  font-size: rem(15);
}
.checkbox {
  display: flex;
  justify-content: space-between;
}
.resolution-list:not(:last-child) .checkbox {
  margin-bottom: rem(10);
}
.suggest-detail {
  height: rem(213);
}
.textarea-suggest {
  height: rem(110);
}
.submit-button {
  position: fixed;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100vw;
  height: rem(93);
  padding: rem(8) rem(15);
  background: #fff;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
}
.button {
  width: rem(345);
  height: rem(44);
  color: #fff;
  font-weight: bold;
  font-size: rem(16);
  line-height: rem(44);
  text-align: center;
  background: #1c91e0;
  border-radius: rem(2);
}
</style>
